import * as React from "react";
const SvgImgNew = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <circle cx={9} cy={9} r={8} fill="#F53F29" />
    <path fill="#fff" d="M10.627 5.5h1.5v7h-1.3l-3.45-4.45v4.45h-1.5v-7h1.3l3.45 4.45z" />
  </svg>
);
export default SvgImgNew;
